// Reconstructed from the supplied production build; original component names were unavailable.
import {
  BuildingIcon,
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  CircleCheckBigIcon,
  CircleXIcon,
  ClockIcon,
  FileTextIcon,
  React,
  RefreshCwIcon,
  SearchIcon,
  UserIcon,
  motion,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const WithdrawalsPage = () => {
  const [e, t] = React.useState([]),
    [n, r] = React.useState([]),
    [a, l] = React.useState(true),
    [c, d] = React.useState(null),
    [f, h] = React.useState(""),
    [p, g] = React.useState(null),
    [y, v] = React.useState(""),
    [j, N] = React.useState(""),
    [b, S] = React.useState(""),
    [O, _] = React.useState(false),
    [C, A] = React.useState(false),
    [T, M] = React.useState("pending"),
    [k, $] = React.useState(1),
    [I, U] = React.useState(1),
    q = 10;
  React.useEffect(() => {
    z();
  }, []);
  const z = async () => {
      try {
        l(true);
        const $e = (await api.get("/admin/withdrawals")).data.map((Ve) => ({
            ...Ve,
            accountName: Ve.accountName || "N/A",
            accountNumber: Ve.accountNumber || "N/A",
            bankName: Ve.bankName || "N/A",
            ifscCode: Ve.ifscCode || "N/A",
            originalNotes: Ve.notes || "",
          })),
          Ae = $e.filter((Ve) => Ve.status === "pending"),
          st = $e.filter((Ve) => Ve.status === "completed" || Ve.status === "failed");
        (t(Ae), r(st), d(null));
      } catch (oe) {
        (console.error("Error fetching withdrawals:", oe),
          d("Failed to load withdrawal requests. Please try again later."));
      } finally {
        l(false);
      }
    },
    Y = (oe) => {
      (g(oe), v(""), N(""), _(true));
    },
    F = (oe) => {
      (g(oe), S(""), A(true));
    },
    B = async () => {
      if (!p || !y.trim()) {
        d("Reference ID is required for approval");
        return;
      }
      try {
        (l(true),
          await api.post(`/admin/withdrawals/${p.id}/approve`, {
            reference_id: y.trim(),
            notes: j.trim() || "Withdrawal approved by admin",
          }),
          await z(),
          _(false),
          g(null),
          v(""),
          N(""));
      } catch (oe) {
        (console.error("Error approving withdrawal:", oe),
          d("Failed to approve withdrawal. Please try again later."));
      } finally {
        l(false);
      }
    },
    K = async () => {
      if (p)
        try {
          (l(true),
            await api.post(`/admin/withdrawals/${p.id}/reject`, {
              notes: b || "Withdrawal rejected by admin",
            }),
            await z(),
            A(false),
            g(null));
        } catch (oe) {
          (console.error("Error rejecting withdrawal:", oe),
            d("Failed to reject withdrawal. Please try again later."));
        } finally {
          l(false);
        }
    },
    ne = (() => {
      const oe =
        T === "pending"
          ? e
          : T === "completed"
            ? n.filter((ce) => ce.status === "completed")
            : n.filter((ce) => ce.status === "failed");
      return f
        ? oe.filter(
            (ce) =>
              (ce.agent_name && ce.agent_name.toLowerCase().includes(f.toLowerCase())) ||
              (ce.agent_id && ce.agent_id.toString().toLowerCase().includes(f.toLowerCase())) ||
              (ce.reference_id && ce.reference_id.toLowerCase().includes(f.toLowerCase())) ||
              (ce.accountNumber && ce.accountNumber.toLowerCase().includes(f.toLowerCase())),
          )
        : oe;
    })(),
    L = Math.ceil(ne.length / q),
    ee = ((T === "pending" ? k : I) - 1) * q,
    re = ee + q,
    R = ne.slice(ee, re);
  React.useEffect(() => {
    ($(1), U(1));
  }, [f, T]);
  const W = (oe) => {
      T === "pending" ? $(oe) : U(oe);
    },
    xe = () => {
      const oe = T === "pending" ? k : I;
      oe > 1 && W(oe - 1);
    },
    ve = () => {
      const oe = T === "pending" ? k : I;
      oe < L && W(oe + 1);
    },
    te = () => {
      const oe = [],
        $e = T === "pending" ? k : I;
      if (L <= 5) for (let Ae = 1; Ae <= L; Ae++) oe.push(Ae);
      else if ($e <= 3) {
        for (let Ae = 1; Ae <= 4; Ae++) oe.push(Ae);
        (oe.push("..."), oe.push(L));
      } else if ($e >= L - 2) {
        (oe.push(1), oe.push("..."));
        for (let Ae = L - 3; Ae <= L; Ae++) oe.push(Ae);
      } else {
        (oe.push(1), oe.push("..."));
        for (let Ae = $e - 1; Ae <= $e + 1; Ae++) oe.push(Ae);
        (oe.push("..."), oe.push(L));
      }
      return oe;
    },
    ye = (oe) => {
      switch (oe) {
        case "pending":
          return (
            <span
              className={
                "px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full items-center bg-yellow-100 text-yellow-800"
              }
            >
              <ClockIcon className={"w-3 h-3 mr-1"} />
              {"Pending"}
            </span>
          );
      }
    },
    V = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  if (a && e.length === 0 && n.length === 0)
    return (
      <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
          <div className={"flex items-center justify-center h-screen"}>
          <div className={"p-8 flex flex-col items-center"}>
            <div className={"w-16 h-16 relative"}>
              <div
                className={
                  "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
                }
              />
              <div
                className={
                  "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
                }
              />
            </div>
            <p className={"mt-4 text-gray-600"}>{"Loading withdrawals..."}</p>
          </div>
        </div>
      </div>
    );
  const de = () => (
    <div className={"bg-white rounded-2xl shadow-lg overflow-hidden"}>
      <div className={"overflow-x-auto"}>
        <table className={"min-w-full divide-y divide-gray-200"}>
          <thead>
            <tr>
              <th
                scope={"col"}
                className={
                  "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                }
              >
                {"Date"}
              </th>
              <th
                scope={"col"}
                className={
                  "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                }
              >
                {"Agent"}
              </th>
              <th
                scope={"col"}
                className={
                  "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                }
              >
                {"Account Details"}
              </th>
              <th
                scope={"col"}
                className={
                  "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                }
              >
                {"Bank Info"}
              </th>
              <th
                scope={"col"}
                className={
                  "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                }
              >
                {"Amount"}
              </th>
              <th
                scope={"col"}
                className={
                  "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                }
              >
                {"Status"}
              </th>
              {T === "pending" && (
                <th
                  scope={"col"}
                  className={
                    "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                  }
                >
                  {"Actions"}
                </th>
              )}
              {T !== "pending" && (
                <th
                  scope={"col"}
                  className={
                    "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                  }
                >
                  {"Notes"}
                </th>
              )}
            </tr>
          </thead>
          <tbody className={"bg-white divide-y divide-gray-200"}>
            {R.map((oe) => (
              <tr key={oe.id} className={"hover:bg-gray-50 transition duration-150"}>
                <td className={"px-6 py-4 whitespace-nowrap"}>
                  <div className={"flex items-center text-sm text-gray-600"}>
                    <CalendarIcon className={"w-4 h-4 mr-2 text-gray-400"} />
                    {oe.created_at
                      ? new Date(oe.created_at).toLocaleDateString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : "N/A"}
                  </div>
                </td>
                <td className={"px-6 py-4 whitespace-nowrap"}>
                  <div className={"flex items-center"}>
                    <div
                      className={
                        "flex-shrink-0 h-8 w-8 rounded-full bg-purple-100 flex items-center justify-center"
                      }
                    >
                      <UserIcon className={"h-4 w-4 text-purple-600"} />
                    </div>
                    <div className={"ml-3"}>
                      <div className={"text-sm font-medium text-gray-900"}>
                        {oe.agent_name || "Unknown Agent"}
                      </div>
                      <div className={"text-xs text-gray-500"}>
                        {"ID: "}
                        {oe.agent_id || "No ID"}
                      </div>
                    </div>
                  </div>
                </td>
                <td className={"px-6 py-4"}>
                  <div className={"text-sm"}>
                    <div className={"font-medium text-gray-900"}>{oe.accountName}</div>
                    <div className={"text-gray-500"}>{oe.accountNumber}</div>
                  </div>
                </td>
                <td className={"px-6 py-4"}>
                  <div className={"text-sm"}>
                    <div className={"flex items-center text-gray-900"}>
                      <BuildingIcon className={"w-4 h-4 mr-1 text-gray-400"} />
                      {oe.bankName}
                    </div>
                    <div className={"text-gray-500 text-xs"}>
                      {"IFSC: "}
                      {oe.ifscCode}
                    </div>
                  </div>
                </td>
                <td className={"px-6 py-4 whitespace-nowrap"}>
                  <div className={"text-sm font-medium text-red-600"}>
                    {"₹"}
                    {typeof oe.amount == "number" || typeof oe.amount == "string"
                      ? parseFloat(oe.amount).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </div>
                </td>
                <td className={"px-6 py-4 whitespace-nowrap"}>{ye(oe.status)}</td>
                {T === "pending" ? (
                  <td className={"px-6 py-4 whitespace-nowrap text-sm font-medium"}>
                    <div className={"flex space-x-2"}>
                      <button
                        onClick={() => Y(oe)}
                        className={
                          "p-2 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 transition-colors flex items-center"
                        }
                        title={"Approve"}
                      >
                        <CircleCheckBigIcon className={"h-4 w-4"} />
                      </button>
                      <button
                        onClick={() => F(oe)}
                        className={
                          "p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors flex items-center"
                        }
                        title={"Reject"}
                      >
                        <CircleXIcon className={"h-4 w-4"} />
                      </button>
                      <button
                        className={
                          "p-2 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors flex items-center"
                        }
                        title={"View Details"}
                      >
                        <FileTextIcon className={"h-4 w-4"} />
                      </button>
                    </div>
                  </td>
                ) : (
                  <td className={"px-6 py-4"}>
                    <div className={"text-sm text-gray-600 max-w-xs truncate"}>
                      {oe.originalNotes || "-"}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {L > 1 && (
        <div className={"bg-white px-4 py-3 border-t border-gray-200 sm:px-6"}>
          <div className={"flex items-center justify-between"}>
            <div className={"flex-1 flex justify-between sm:hidden"}>
              <button
                onClick={xe}
                disabled={(T === "pending" ? k : I) === 1}
                className={
                  "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                }
              >
                {"Previous"}
              </button>
              <button
                onClick={ve}
                disabled={(T === "pending" ? k : I) === L}
                className={
                  "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                }
              >
                {"Next"}
              </button>
            </div>
            <div className={"hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"}>
              <div>
                <p className={"text-sm text-gray-700"}>
                  {"Showing page "}
                  <span className={"font-medium"}>{T === "pending" ? k : I}</span>
                  {" of"} <span className={"font-medium"}>{L}</span>
                </p>
              </div>
              <div>
                <nav
                  className={"relative z-0 inline-flex rounded-md shadow-sm -space-x-px"}
                  aria-label={"Pagination"}
                >
                  <button
                    onClick={xe}
                    disabled={(T === "pending" ? k : I) === 1}
                    className={
                      "relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    }
                  >
                    <span className={"sr-only"}>{"Previous"}</span>
                    <ChevronLeftIcon className={"h-5 w-5"} />
                  </button>
                  {te().map((oe, ce) => (
                    <button
                      key={ce}
                      onClick={() => oe !== "..." && W(oe)}
                      disabled={oe === "..."}
                      className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${oe === (T === "pending" ? k : I) ? "z-10 bg-purple-50 border-purple-500 text-purple-600" : oe === "..." ? "border-gray-300 bg-white text-gray-700 cursor-default" : "border-gray-300 bg-white text-gray-500 hover:bg-gray-50"}`}
                    >
                      {oe}
                    </button>
                  ))}
                  <button
                    onClick={ve}
                    disabled={(T === "pending" ? k : I) === L}
                    className={
                      "relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    }
                  >
                    <span className={"sr-only"}>{"Next"}</span>
                    <ChevronRightIcon className={"h-5 w-5"} />
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
  return (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div initial={"hidden"} animate={"visible"} variants={V} className={"mb-8"}>
          <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"Withdrawal Requests"}</h1>
          <p className={"text-gray-600"}>{"Manage and process agent withdrawal requests"}</p>
        </motion.div>
        {c && (
          <motion.div initial={"hidden"} animate={"visible"} variants={V} className={"mb-6"}>
            <div
              className={"bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md"}
              role={"alert"}
            >
              <p className={"font-medium"}>{"Error"}</p>
              <p>{c}</p>
            </div>
          </motion.div>
        )}
        <motion.div initial={"hidden"} animate={"visible"} variants={V} className={"mb-6"}>
          <div className={"border-b border-gray-200"}>
            <nav className={"-mb-px flex space-x-8"}>
              <button
                onClick={() => M("pending")}
                className={`py-2 px-1 border-b-2 font-medium text-sm ${T === "pending" ? "border-purple-500 text-purple-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}`}
              >
                <div className={"flex items-center"}>
                  <ClockIcon className={"w-4 h-4 mr-2"} />
                  {"Pending ("}
                  {e.length}
                  {")"}
                </div>
              </button>
            </nav>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={V} className={"mb-6"}>
          <div
            className={
              "flex flex-col md:flex-row justify-between items-center bg-white p-4 rounded-xl shadow-sm"
            }
          >
            <div className={"w-full md:w-auto mb-4 md:mb-0"}>
              <div className={"relative"}>
                <div
                  className={"absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"}
                >
                  <SearchIcon className={"h-5 w-5 text-gray-400"} />
                </div>
                <input
                  type={"text"}
                  placeholder={"Search by agent name, ID, reference ID, or account number"}
                  className={
                    "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                  }
                  value={f}
                  onChange={(oe) => h(oe.target.value)}
                />
              </div>
            </div>
            <div className={"flex items-center space-x-4"}>
              <span className={"text-sm text-gray-600"}>
                {"Showing "}
                {Math.min(ee + 1, ne.length)}
                {"-"}
                {Math.min(re, ne.length)}
                {" of "}
                {ne.length}
                {" results"}
              </span>
              <button
                onClick={z}
                className={
                  "flex items-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
                }
                disabled={a}
              >
                <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                {"Refresh"}
              </button>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={V}>
          {ne.length > 0 ? (
            de()
          ) : (
            <div className={"bg-white rounded-2xl shadow-lg p-12 text-center"}>
              <div className={"flex flex-col items-center justify-center"}>
                <div
                  className={
                    "w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center text-gray-500 mb-6"
                  }
                >
                  {T === "pending" && <ClockIcon className={"h-12 w-12"} />}
                  {T === "completed" && <CircleCheckBigIcon className={"h-12 w-12"} />}
                  {T === "failed" && <CircleXIcon className={"h-12 w-12"} />}
                </div>
                <h3 className={"text-xl font-bold text-gray-800 mb-2"}>
                  {f ? `No matching ${T} withdrawals found` : `No ${T} withdrawals`}
                </h3>
                <p className={"text-gray-500 mb-6"}>
                  {f
                    ? "Try adjusting your search criteria"
                    : T === "pending"
                      ? "All withdrawal requests have been processed"
                      : `No ${T} withdrawal records found`}
                </p>
                {f && (
                  <button
                    onClick={() => h("")}
                    className={
                      "flex items-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors mb-4"
                    }
                  >
                    {"Clear Search"}
                  </button>
                )}
                <button
                  onClick={z}
                  className={
                    "flex items-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
                  }
                >
                  <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                  {"Refresh Data"}
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </main>
      {O && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl max-w-md w-full p-6"}>
            <h3 className={"text-lg font-bold text-gray-900 mb-4"}>{"Approve Withdrawal"}</h3>
            <div className={"mb-6"}>
              <div className={"space-y-3"}>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Agent"}</span>
                  <span className={"font-medium"}>{p == null ? undefined : p.agent_name}</span>
                </div>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Amount"}</span>
                  <span className={"font-medium text-red-600"}>
                    {"₹"}
                    {parseFloat((p == null ? undefined : p.amount) || 0).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Bank"}</span>
                  <span className={"font-medium"}>
                    {(p == null ? undefined : p.bankName) || "N/A"}
                  </span>
                </div>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Account"}</span>
                  <span className={"font-medium"}>
                    {(p == null ? undefined : p.accountNumber) || "N/A"}
                  </span>
                </div>
              </div>
              <div className={"mt-4"}>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Reference ID *"}
                </label>
                <input
                  type={"text"}
                  className={
                    "w-full border border-gray-300 rounded-lg p-2 focus:ring-purple-500 focus:border-purple-500"
                  }
                  value={y}
                  onChange={(oe) => v(oe.target.value)}
                  placeholder={"Enter transaction reference ID"}
                  required={true}
                />
              </div>
              <div className={"mt-4"}>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>{"Notes"}</label>
                <textarea
                  className={
                    "w-full border border-gray-300 rounded-lg p-2 focus:ring-purple-500 focus:border-purple-500"
                  }
                  rows={"3"}
                  value={j}
                  onChange={(oe) => N(oe.target.value)}
                  placeholder={"Enter additional notes (optional)"}
                />
              </div>
            </div>
            <div className={"flex justify-end space-x-3"}>
              <button
                onClick={() => _(false)}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                }
              >
                {"Cancel"}
              </button>
              <button
                onClick={B}
                className={
                  "px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center"
                }
                disabled={a || !y.trim()}
              >
                {a ? "Processing..." : "Approve Withdrawal"}
              </button>
            </div>
          </div>
        </div>
      )}
      {C && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl max-w-md w-full p-6"}>
            <h3 className={"text-lg font-bold text-gray-900 mb-4"}>{"Reject Withdrawal"}</h3>
            <div className={"mb-6"}>
              <div className={"space-y-3"}>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Agent"}</span>
                  <span className={"font-medium"}>{p == null ? undefined : p.agent_name}</span>
                </div>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Amount"}</span>
                  <span className={"font-medium text-red-600"}>
                    {"₹"}
                    {parseFloat((p == null ? undefined : p.amount) || 0).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Bank"}</span>
                  <span className={"font-medium"}>
                    {(p == null ? undefined : p.bankName) || "N/A"}
                  </span>
                </div>
                <div className={"flex justify-between items-center bg-gray-50 p-3 rounded-lg"}>
                  <span className={"text-sm text-gray-500"}>{"Account"}</span>
                  <span className={"font-medium"}>
                    {(p == null ? undefined : p.accountNumber) || "N/A"}
                  </span>
                </div>
              </div>
              <div className={"mt-4"}>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Rejection Reason"}
                </label>
                <textarea
                  className={
                    "w-full border border-gray-300 rounded-lg p-2 focus:ring-purple-500 focus:border-purple-500"
                  }
                  rows={"3"}
                  value={b}
                  onChange={(oe) => S(oe.target.value)}
                  placeholder={"Enter reason for rejecting this withdrawal request"}
                />
              </div>
            </div>
            <div className={"flex justify-end space-x-3"}>
              <button
                onClick={() => A(false)}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                }
              >
                {"Cancel"}
              </button>
              <button
                onClick={K}
                className={
                  "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center"
                }
                disabled={a}
              >
                {a ? "Processing..." : "Reject Withdrawal"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export { WithdrawalsPage };
